// SVG Icon exports - these will be transformed by react-native-svg-transformer
import IcAroundthegreen from './ic-aroundthegreen.svg';
import IcAtg from './ic-atg.svg';
import IcBackBlue from './ic-back-blue.svg';
import IcBack from './ic-back.svg';
import IcCalendar from './ic-calendar.svg';
import IcCall from './ic-call.svg';
import IcCheck from './ic-check.svg';
import IcCheckboxChecked from './ic-checked.svg';
import IcCheckList from './ic-checklist.svg';
import IcClear from './ic-clear.svg';
import IcClock from './ic-clock.svg';
import IcClose from './ic-close.svg';
import IcCompletedFill from './ic-completed-fill.svg';
import IcCompleted from './ic-completed.svg';
import IcEdit from './ic-edit.svg';
import IcEnvelope from './ic-envelope.svg';
import IcEyeOff from './ic-eye-off.svg';
import IcEye from './ic-eye.svg';
import IcFilter from './ic-filter.svg';
import IcForm from './ic-form.svg';
import { default as IcFullSwing, default as IcFullswing } from './ic-fullswing.svg';
import IcHome from './ic-home.svg';
import IcKnowledge from './ic-knowledge.svg';
import IcLink from './ic-link.svg';
import IcLock from './ic-lock.svg';
import IcMail from './ic-mail.svg';
import IcMastery from './ic-mastery.svg';
import IcPackage from './ic-package.svg';
import IcPaginationArrow from './ic-pagination-arrow.svg';
import IcPlayerChecked from './ic-player-checked.svg';
import IcPlayerPathway from './ic-player-pathway.svg';
import IcPlayerUnchecked from './ic-player-uncheck.svg';
import IcPlusPlain from './ic-plus-plain.svg';
import IcPlus from './ic-plus.svg';
import IcPutting from './ic-putting.svg';
import IcRadioChecked from './ic-radio-checked.svg';
import IcRadioUnchecked from './ic-radio-unchecked.svg';
import IcRefresh from './ic-refresh.svg';
import IcScore from './ic-score.svg';
import IcSearch from './ic-search.svg';
import IcSkill1 from './ic-skill1.svg';
import IcSkill2 from './ic-skill2.svg';
import IcSort from './ic-sort.svg';
import IcStop from './ic-stop.svg';
import IcText from './ic-text.svg';
import IcTrash from './ic-trash.svg';
import IcCheckboxUnchecked from './ic-unchecked.svg';
import IcPlayer from './ic-user.svg';

// Icon name mapping for the SvgIcon component
export const iconRegistry = {
  IcScore,
  IcCheckList,
  IcClock,
  IcChecked: IcPlayerChecked,
  IcUnchecked: IcPlayerUnchecked,
  IcPlayerChecked,
  IcPlayerUnchecked,
  IcCompleted,
  IcTrash,
  IcPlus,
  IcCall,
  IcMail,
  IcEdit,
  IcText,
  IcClose,
  IcBackBlue,
  IcSort,
  IcFilter,
  IcCheckboxChecked,
  IcCheckboxUnchecked,
  IcEnvelope,
  IcRadioChecked,
  IcRadioUnchecked,
  IcHome,
  IcPlayer,
  IcPlayerPathway,
  IcLock,
  IcPaginationArrow,
  IcSearch,
  IcBack,
  IcEye,
  IcEyeOff,
  IcCalendar,
  IcPackage,
  IcPlusPlain,
  IcStop,
  IcPutting,
  IcAtg,
  IcFullSwing,
  IcKnowledge,
  IcForm,
  IcSkill1,
  IcSkill2,
  IcCompletedFill,
  IcMastery,
  IcAroundthegreen,
  IcFullswing,
  IcCheck,
  IcClear,
  IcLink,
  IcRefresh,
} as const;

export type AvailableIconName = keyof typeof iconRegistry;
